<li class="banner-message-text paragraph-small" [innerHTML]="notificationMessage"></li>
